import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { SKU_$reflection, Money_$reflection } from "./Common.js";
import { option_type, tuple_type, record_type, int32_type, class_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";

export class EventType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProductSupplyReceived", "StockAdjusted"];
    }
}

export function EventType_$reflection() {
    return union_type("Shopfoo.Domain.Types.Warehouse.EventType", [], EventType, () => [[["purchasePrice", Money_$reflection()]], []]);
}

export class StockEvent extends Record {
    constructor(SKU, Date$, Quantity, Type) {
        super();
        this.SKU = SKU;
        this.Date = Date$;
        this.Quantity = (Quantity | 0);
        this.Type = Type;
    }
}

export function StockEvent_$reflection() {
    return record_type("Shopfoo.Domain.Types.Warehouse.StockEvent", [], StockEvent, () => [["SKU", SKU_$reflection()], ["Date", class_type("System.DateOnly")], ["Quantity", int32_type], ["Type", EventType_$reflection()]]);
}

export function StockEventModule_mapPurchasePrice(f, stockEvent) {
    const matchValue = stockEvent.Type;
    if (matchValue.tag === 1) {
        return stockEvent;
    }
    else {
        return new StockEvent(stockEvent.SKU, stockEvent.Date, stockEvent.Quantity, new EventType(0, [f(matchValue.fields[0])]));
    }
}

export class Stock extends Record {
    constructor(SKU, Quantity) {
        super();
        this.SKU = SKU;
        this.Quantity = (Quantity | 0);
    }
}

export function Stock_$reflection() {
    return record_type("Shopfoo.Domain.Types.Warehouse.Stock", [], Stock, () => [["SKU", SKU_$reflection()], ["Quantity", int32_type]]);
}

export class ReceiveSupplyInput extends Record {
    constructor(SKU, Date$, Quantity, PurchasePrice) {
        super();
        this.SKU = SKU;
        this.Date = Date$;
        this.Quantity = (Quantity | 0);
        this.PurchasePrice = PurchasePrice;
    }
}

export function ReceiveSupplyInput_$reflection() {
    return record_type("Shopfoo.Domain.Types.Warehouse.ReceiveSupplyInput", [], ReceiveSupplyInput, () => [["SKU", SKU_$reflection()], ["Date", class_type("System.DateOnly")], ["Quantity", int32_type], ["PurchasePrice", Money_$reflection()]]);
}

export class PurchasePrices extends Record {
    constructor(LastPrice, AverageOver1Y) {
        super();
        this.LastPrice = LastPrice;
        this.AverageOver1Y = AverageOver1Y;
    }
}

export function PurchasePrices_$reflection() {
    return record_type("Shopfoo.Domain.Types.Warehouse.PurchasePrices", [], PurchasePrices, () => [["LastPrice", option_type(tuple_type(Money_$reflection(), class_type("System.DateOnly")))], ["AverageOver1Y", option_type(Money_$reflection())]]);
}

export function PurchasePrices_get_Empty() {
    return new PurchasePrices(undefined, undefined);
}

